import { AudioReactionDialog } from "./AudioReactionDialog";
import { useAudioReactionsSubscription } from "./hooks";
import { PlaySoundHandler } from "./components/PlaySoundHandler";

export const AudioReactions = () => {
  useAudioReactionsSubscription();

  return (
    <>
      <PlaySoundHandler />
      <AudioReactionDialog />
    </>
  );
};
